import type { KeyOf } from '../types/masterdata-key';

/** Best-guess key extractor when a definition has no `keyWith`: `key` → `number` → `customerNumber` → `id`. */
export function defaultKeyOf(entity: any): string | number | null | undefined {
  return (
    entity?.key ??
    entity?.number ??
    entity?.customerNumber ??
    entity?.id
  );
}

/** Normalize a key/term for exact comparison: string, trimmed, lower-cased. */
function normalize(value: string | number | null | undefined): string | null {
  if (value == null) return null;
  const s = String(value).trim().toLowerCase();
  return s.length ? s : null;
}

/** The unique result whose key equals `term` (case-insensitive, trimmed); null when
 *  the term is empty or 0/2+ results match — never silently select an ambiguous hit. */
export function findDirectKeyMatch<T>(
  results: readonly T[] | null | undefined,
  term: string | null | undefined,
  keyOf: KeyOf<T>
): T | null {
  const needle = normalize(term);
  if (!needle) return null;
  const matches = (results ?? []).filter((e) => normalize(keyOf(e)) === needle);
  return matches.length === 1 ? matches[0] : null;
}
